import { render, staticRenderFns } from "./DatosDocumentos.vue?vue&type=template&id=2d474774&"
import script from "./DatosDocumentos.vue?vue&type=script&lang=js&"
export * from "./DatosDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports